import { call, put, takeEvery } from 'redux-saga/effects';
import {getAllDevicesAPI, getDevicesByUserId} from "../api/deviceAPI";
import { DEVICE } from '../actions/device';
import DeviceConverter from '../models/device/deviceConverter';
import axios from "axios/index";
import {setEndpoint} from "../util/util";
import { showNotification } from 'admin-on-rest';

/*************************** CALLS ***************************/

export function* fetchAllDevicesCall() {
  try {
    const response = yield getAllDevicesAPI();
    const data = DeviceConverter.fromAPIDevicesResponse(response);
    yield put({ type: DEVICE.SET_ALL, payload: {data: data} });
  }
  catch (error) {
    console.info("[saga.device fetch all] error: ", error);
    yield put({ type: DEVICE.FETCH_ALL_FAILED });
  }
}

export function* fetchDevicesByUserIdCall(action) {
  try {
    const userId = action.payload.data;
    const response = yield getDevicesByUserId(userId);
    const data = DeviceConverter.fromAPIDevicesResponse(response);
    yield put({ type: DEVICE.SET_ALL, payload: {data: data} });
  }
  catch (error) {
    console.info("[saga.device fetch by user id] error: ", error);
    yield put({ type: DEVICE.SET_ALL, payload: {data: null} });
    yield put({ type: DEVICE.FETCH_BY_USER_ID_FAILED });
  }
}

export function* registerDeviceCall(action) {
  try {
    const payload = action.payload.data;
    let endpoint = setEndpoint("devices/register");
    const response = yield call(axios.put, endpoint, payload);
    if(response.data !== "") {
      yield put({ type: DEVICE.SET_REGISTERED, payload: {data: response.data} });
      yield put(showNotification("Device added"));
    }
    else{
      yield put(showNotification("Device already added", "warning"));
    }
  }
  catch (error) {
    console.info("[saga.device register] error: ", error);
    yield put(showNotification("Device adding failed", "warning"));
  }
}

/*************************** WATCH ***************************/

export function* fetchAllDevicesWatch() {
  yield takeEvery(DEVICE.FETCH_ALL, fetchAllDevicesCall);
}

export function* reFetchAllDevicesWatch() {
  yield takeEvery(DEVICE.RE_FETCH_ALL, fetchAllDevicesCall);
}

export function* fetchDevicesByUserIdWatch() {
  yield takeEvery(DEVICE.FETCH_BY_USER_ID, fetchDevicesByUserIdCall);
}

export function* reFetchDevicesByUserIdWatch() {
  yield takeEvery(DEVICE.RE_FETCH_BY_USER_ID, fetchDevicesByUserIdCall);
}

export function* registerDeviceWatch() {
  yield takeEvery(DEVICE.REGISTER, registerDeviceCall);
}


// WEBPACK FOOTER //
// ./src/sagas/device.js